export const isCJKCharacter = (char: string) => {
    return /[\u4e00-\u9fa5\u3040-\u30ff\u3130-\u318f\uac00-\ud7af]/.test(char);
};
